import type { EmployeeViewModel, FunctionViewModel } from '@trinnvis/dabih-api-client';

export function isTreatmentProvider(e: EmployeeViewModel, functions: FunctionViewModel[]): boolean {
  const treatmentProviderFunctions = functions.filter(function (item) {
    return (
      item.employees.includes(e.uuid) &&
      (item.templateId === 3765 || // lege
        item.templateId === 3784 || // fysioterapeut
        item.templateId === 3777 || // tannlege
        item.templateId === 3775 || // kiropraktor
        item.templateId === 3775 || // kiropraktor
        item.templateId === 3769) // psykolog
    );
  });
  return treatmentProviderFunctions.length > 0;
}
